import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";

import {
  showRightSidebarAction,
  changeFontScale,
  changeFontFamily,
  changeFontColor,
  changeUiTheme,
} from "../../store/actions";
import {
  fontScaleTypes,
  fontFamilyTypes,
  fontColorTypes,
  uiThemeTypes,
  FONT_SCALE_STORAGE_KEY,
  FONT_FAMILY_STORAGE_KEY,
  FONT_COLOR_STORAGE_KEY,
  UI_THEME_STORAGE_KEY,
} from "../../constants/layout";
import { saveHeaderSettingUserSetting } from "../../model/UserSettingModel";

import "../../components/CommonForBoth/rightbar.scss";

const RightSidebar = (props) => {
  const handleFontScaleChange = (nextValue) => {
    props.changeFontScale(nextValue);
    saveHeaderSettingUserSetting(FONT_SCALE_STORAGE_KEY, nextValue);
  };

  const handleFontFamilyChange = (nextValue) => {
    props.changeFontFamily(nextValue);
    saveHeaderSettingUserSetting(FONT_FAMILY_STORAGE_KEY, nextValue);
  };

  const handleFontColorChange = (nextValue) => {
    props.changeFontColor(nextValue);
    saveHeaderSettingUserSetting(FONT_COLOR_STORAGE_KEY, nextValue);
  };

  const handleUiThemeChange = (nextValue) => {
    props.changeUiTheme(nextValue);
    saveHeaderSettingUserSetting(UI_THEME_STORAGE_KEY, nextValue);
  };

  return (
    <React.Fragment>
      <div className="right-bar" id="right-bar">
        <SimpleBar style={{ height: "100%" }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.showRightSidebarAction(false);
                }}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <h5 className="m-0">Settings</h5>
            </div>

            <hr className="my-0" />

            <div className="p-4 pick-your-style">
              <h5 className="pick-your-style__title mb-4">Pick your style</h5>

              <div className="radio-toolbar pick-your-style__block">
                <span className="mb-3 d-block fw-semibold">Font Size</span>
                <input
                  type="radio"
                  id="fontScaleSmall"
                  name="fontScale"
                  value={fontScaleTypes.SMALL}
                  checked={props.fontScale === fontScaleTypes.SMALL}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontScaleChange(e.target.value);
                    }
                  }}
                />
                <label className="me-1" htmlFor="fontScaleSmall">
                  Small
                </label>
                <input
                  type="radio"
                  id="fontScaleCurrent"
                  name="fontScale"
                  value={fontScaleTypes.CURRENT}
                  checked={props.fontScale === fontScaleTypes.CURRENT}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontScaleChange(e.target.value);
                    }
                  }}
                />
                <label className="me-1" htmlFor="fontScaleCurrent">
                  Default
                </label>
                <input
                  type="radio"
                  id="fontScaleLarge"
                  name="fontScale"
                  value={fontScaleTypes.LARGE}
                  checked={props.fontScale === fontScaleTypes.LARGE}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontScaleChange(e.target.value);
                    }
                  }}
                />
                <label htmlFor="fontScaleLarge">Large</label>
              </div>

              <hr className="pick-your-style__divider" />

              <div className="pick-your-style__section pick-your-style__block">
                <label
                  className="pick-your-style__label mb-3 d-block fw-semibold"
                  htmlFor="fontFamilySelect"
                >
                  Body Font
                </label>
                <select
                  id="fontFamilySelect"
                  className="form-select pick-your-style__select"
                  value={props.fontFamily || fontFamilyTypes.POPPINS}
                  onChange={(e) => handleFontFamilyChange(e.target.value)}
                >
                  <option value={fontFamilyTypes.POPPINS}>Poppins</option>
                  <option value={fontFamilyTypes.ROBOTO}>Roboto</option>
                  <option value={fontFamilyTypes.OPEN_SANS}>Open Sans</option>
                </select>
              </div>

              <hr className="pick-your-style__divider" />

              <div className="radio-toolbar pick-your-style__font-color pick-your-style__block">
                <span className="mb-3 d-block fw-semibold">Font Color</span>
                <input
                  type="radio"
                  id="fontColorCurrent"
                  name="fontColor"
                  value={fontColorTypes.CURRENT}
                  checked={
                    (props.fontColor || fontColorTypes.CURRENT) ===
                    fontColorTypes.CURRENT
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--current"
                  htmlFor="fontColorCurrent"
                  title="Default"
                  aria-label="Default"
                />
                {/* <input
                  type="radio"
                  id="fontColorCharcoal"
                  name="fontColor"
                  value={fontColorTypes.CHARCOAL}
                  checked={props.fontColor === fontColorTypes.CHARCOAL}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                /> */}
                {/* <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--charcoal"
                  htmlFor="fontColorCharcoal"
                  title="Charcoal — higher contrast"
                >
                  Charcoal
                </label>
                <input
                  type="radio"
                  id="fontColorSoftNavy"
                  name="fontColor"
                  value={fontColorTypes.SOFT_NAVY}
                  checked={props.fontColor === fontColorTypes.SOFT_NAVY}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                /> */}
                {/* <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--soft-navy"
                  htmlFor="fontColorSoftNavy"
                  title="Soft Navy — easier long reading"
                >
                  Soft Navy
                </label> */}
                <input
                  type="radio"
                  id="fontColorRed"
                  name="fontColor"
                  value={fontColorTypes.RED}
                  checked={props.fontColor === fontColorTypes.RED}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--red"
                  htmlFor="fontColorRed"
                  title="Deep Teal"
                  aria-label="Deep Teal"
                />
                <input
                  type="radio"
                  id="fontColorPrimary"
                  name="fontColor"
                  value={fontColorTypes.PRIMARY}
                  checked={props.fontColor === fontColorTypes.PRIMARY}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--primary"
                  htmlFor="fontColorPrimary"
                  title="Primary"
                  aria-label="Primary"
                />
                <input
                  type="radio"
                  id="fontColorDeepSapphire"
                  name="fontColor"
                  value={fontColorTypes.DEEP_SAPPHIRE}
                  checked={props.fontColor === fontColorTypes.DEEP_SAPPHIRE}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="me-1 pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--deep-sapphire"
                  htmlFor="fontColorDeepSapphire"
                  title="Deep Sapphire"
                  aria-label="Deep Sapphire"
                />
                <input
                  type="radio"
                  id="fontColorDeepBlack"
                  name="fontColor"
                  value={fontColorTypes.DEEP_BLACK}
                  checked={props.fontColor === fontColorTypes.DEEP_BLACK}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--deep-black"
                  htmlFor="fontColorDeepBlack"
                  title="Deep Black"
                  aria-label="Deep Black"
                />
                {/* <input
                  type="radio"
                  id="fontColorDeepMaroon"
                  name="fontColor"
                  value={fontColorTypes.DEEP_MAROON}
                  checked={props.fontColor === fontColorTypes.DEEP_MAROON}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleFontColorChange(e.target.value);
                    }
                  }}
                />
                <label
                  className="pick-your-style__color-swatch pick-your-style__color-swatch--chip pick-your-style__color-swatch--deep-maroon"
                  htmlFor="fontColorDeepMaroon"
                  title="Deep Maroon"
                  aria-label="Deep Maroon"
                /> */}
              </div>

              <hr className="pick-your-style__divider" />

              <div className="radio-toolbar pick-your-style__block">
                <span className="mb-3 d-block fw-semibold">Theme</span>
                <input
                  type="radio"
                  id="uiThemeCurrent"
                  name="uiTheme"
                  value={uiThemeTypes.CURRENT}
                  checked={props.uiTheme === uiThemeTypes.CURRENT}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleUiThemeChange(e.target.value);
                    }
                  }}
                />
                <label className="me-2" htmlFor="uiThemeCurrent">
                  Default
                </label>
                <input
                  type="radio"
                  id="uiThemeModern"
                  name="uiTheme"
                  value={uiThemeTypes.MODERN}
                  checked={props.uiTheme === uiThemeTypes.MODERN}
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleUiThemeChange(e.target.value);
                    }
                  }}
                />
                <label htmlFor="uiThemeModern" className="me-2">
                  Advanced
                </label>
                {/* <input
                  type="radio"
                  id="uiThemeDark"
                  name="uiTheme"
                  value={uiThemeTypes.DARK}
                  checked={props.uiTheme === uiThemeTypes.DARK}
                  className="me-1"
                  onChange={(e) => {
                    if (e.target.checked) {
                      handleUiThemeChange(e.target.value);
                    }
                  }}
                />
                <label htmlFor="uiThemeDark" className="me-1">Dark</label> */}
              </div>
              <p className="text-muted small mb-0 mt-4 pick-your-style__hint">
                Theme, font family, font color, and font size are saved and
                restored automatically.
              </p>
            </div>
          </div>
        </SimpleBar>
      </div>
      <div className="rightbar-overlay" />
    </React.Fragment>
  );
};

RightSidebar.propTypes = {
  changeFontScale: PropTypes.func,
  changeFontFamily: PropTypes.func,
  changeFontColor: PropTypes.func,
  changeUiTheme: PropTypes.func,
  fontScale: PropTypes.string,
  fontFamily: PropTypes.string,
  fontColor: PropTypes.string,
  uiTheme: PropTypes.string,
  showRightSidebarAction: PropTypes.func,
};

const mapStateToProps = (state) => ({
  fontScale: state.Layout?.fontScale,
  fontFamily: state.Layout?.fontFamily,
  fontColor: state.Layout?.fontColor,
  uiTheme: state.Layout?.uiTheme,
});

export default connect(mapStateToProps, {
  showRightSidebarAction,
  changeFontScale,
  changeFontFamily,
  changeFontColor,
  changeUiTheme,
})(RightSidebar);
